import { useEffect, useState } from 'react';
import * as R from 'ramda';
import axios from 'axios';

const AccountModal = ({ account, handleClose, handleSave }) => {
  const [form, setForm] = useState(null);
  const [errorMessage, setErrorMessage] = useState({});

  useEffect(() => {
    if (!account) {
      setForm(null);
    } else {
      setForm(R.pick(['email', 'name', 'company', 'phone_number'], account));
    }
  }, [account]);

  const handleForm = (value, id) => {
    form[id] = value;
    setForm({ ...form });
  };

  const onClose = (e) => {
    setErrorMessage({});
    handleClose(e);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage({});
    if (!form || !form['phone_number']) {
      alert('Please enter phone number!');
      return;
    }
    if (!account.id && !form['password']) {
      alert('Please enter password!');
      return;
    }
    if (account?.id) {
      axios
        .post(`/api/v1/accounts/${account?.id}`, { ...form })
        .then(({ data }) => {
          if (data.success) {
            handleSave(data.payload.account);
            onClose(e);
          } else {
            setErrorMessage(data.errors);
          }
        })
        .catch((e) => {
          alert('Can not update account, please try again!');
        });
    } else {
      axios
        .post('/api/v1/accounts', { ...form })
        .then(({ data }) => {
          if (data.success) {
            handleSave(data.payload.account);
            onClose(e);
          } else {
            setErrorMessage(data.errors);
          }
        })
        .catch(() => {
          alert('Can not create new account, please try again!');
        });
    }
  };

  if (!form) return null;
  return (
    <div
      class='relative z-10'
      aria-labelledby='modal-title'
      role='dialog'
      aria-modal='true'
    >
      <div
        class='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity'
        style={{ backgroundColor: '#6f6f6fbf' }}
      ></div>

      <div
        class='fixed inset-0 z-10 w-screen overflow-y-auto'
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <div
          class='flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0'
          style={{ height: '490px', marginTop: '130px' }}
        >
          <div class='relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg'>
            <div class='bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4'>
              <div class='sm:flex sm:items-start'>
                <div class='mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left'>
                  <h3
                    class='text-base font-semibold leading-6 text-gray-900 mt-6'
                    id='modal-title'
                  >
                    Add new account
                  </h3>
                  <div class='mt-2'>
                    <form class='mt-6 space-y-4'>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          columnGap: 10,
                        }}
                      >
                        <div style={{ width: 300 }}>
                          <label class='font-bold'>Phone number</label>
                          <input
                            type='text'
                            class='form-input mt-2 rounded !bg-white border border-[#ced4da] text-base focus:border-custom'
                            placeholder='Phone number'
                            value={form.phone_number}
                            onChange={(e) => {
                              handleForm(e.target.value, 'phone_number');
                            }}
                          />
                          <span style={{ color: 'red' }}>
                            {errorMessage.phone_number}
                          </span>
                        </div>
                        <div style={{ width: 300 }}>
                          <label class='font-bold'>Password</label>
                          <input
                            type='password'
                            class='form-input mt-2 rounded !bg-white border border-[#ced4da] text-base focus:border-custom'
                            placeholder='Password'
                            value={form.password}
                            onChange={(e) => {
                              handleForm(e.target.value, 'password');
                            }}
                          />
                          <span style={{ color: 'red' }}>
                            {errorMessage.password}
                          </span>
                        </div>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          columnGap: 10,
                        }}
                      >
                        <div style={{ width: 300 }}>
                          <label class='font-bold'>Display name</label>
                          <input
                            type='text'
                            class='form-input mt-2 rounded !bg-white border border-[#ced4da] text-base focus:border-custom'
                            placeholder='Display name'
                            value={form.name}
                            onChange={(e) => {
                              handleForm(e.target.value, 'name');
                            }}
                          />
                          <span style={{ color: 'red' }}>
                            {errorMessage.name}
                          </span>
                        </div>
                        <div style={{ width: 300 }}>
                          <label class='font-bold'>Email</label>
                          <input
                            type='text'
                            class='form-input mt-2 rounded !bg-white border border-[#ced4da] text-base focus:border-custom'
                            placeholder='Email'
                            value={form.email}
                            onChange={(e) => {
                              handleForm(e.target.value, 'email');
                            }}
                          />
                          <span style={{ color: 'red' }}>
                            {errorMessage.email}
                          </span>
                        </div>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          columnGap: 10,
                        }}
                      >
                        <div style={{ width: 300 }}>
                          <label class='font-bold'>Company</label>
                          <input
                            type='text'
                            class='form-input mt-2 rounded !bg-white border border-[#ced4da] text-base focus:border-custom'
                            placeholder='Company'
                            value={form.company}
                            onChange={(e) => {
                              handleForm(e.target.value, 'company');
                            }}
                          />
                          <span style={{ color: 'red' }}>
                            {errorMessage.company}
                          </span>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div
              class='bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6'
              style={{ justifyContent: 'flex-end', columnGap: 50 }}
            >
              <button type='button' class='btn py-2' onClick={onClose}>
                Cancel
              </button>
              <button
                type='button'
                class='btn-custom py-2'
                onClick={handleSubmit}
              >
                {account?.id ? 'Save' : 'Create'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountModal;
